export const fmt = {
    money: (n) => (isNaN(Number(n)) ? "—" : `€${Number(n).toFixed(2)}`),
    text: (t) => (t && String(t).trim().length ? t : "—"),
};
